interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  action?: { label: string; href: string };
}

export default function SectionHeading({ eyebrow, title, desc, action }: SectionHeadingProps) {
  return (
    <div className="mb-5 flex flex-col gap-3 md:mb-6 md:flex-row md:items-end md:justify-between">
      <div>
        {eyebrow ? (
          <span className="mb-2 inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
            <span className="flex h-3 w-3 items-center justify-center">
              <i className="ri-price-tag-3-line text-xs"></i>
            </span>
            {eyebrow}
          </span>
        ) : null}
        <h2 className="text-xl font-bold tracking-tight text-foreground-950 md:text-2xl">{title}</h2>
        {desc ? (
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">{desc}</p>
        ) : null}
      </div>
      {action ? (
        <a
          href={action.href}
          className="inline-flex shrink-0 cursor-pointer items-center gap-1 text-sm font-medium text-primary-600 transition-colors hover:text-primary-700 whitespace-nowrap"
        >
          {action.label}
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-arrow-right-s-line text-base"></i>
          </span>
        </a>
      ) : null}
    </div>
  );
}